var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabChange },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("el-tab-pane", {
            attrs: { label: "Logout Events", name: "logout" },
          }),
          _c("el-tab-pane", {
            attrs: { label: "Login Events", name: "login" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "340px" },
            attrs: {
              type: "daterange",
              "range-separator": "to",
              "start-placeholder": "Start Date",
              "end-placeholder": "End Date",
              "value-format": "yyyy-MM-dd",
            },
            on: { change: _vm.handleFilter },
            model: {
              value: _vm.dateRange,
              callback: function ($$v) {
                _vm.dateRange = $$v
              },
              expression: "dateRange",
            },
          }),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "240px" },
            attrs: { placeholder: "Search by email or name...", clearable: "" },
            on: { clear: _vm.handleFilter },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleFilter.apply(null, arguments)
              },
            },
            model: {
              value: _vm.searchText,
              callback: function ($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText",
            },
          }),
          _vm.activeTab === "login"
            ? _c(
                "el-checkbox",
                {
                  staticClass: "filter-item",
                  staticStyle: { "margin-left": "10px" },
                  on: { change: _vm.handleFilter },
                  model: {
                    value: _vm.onlyFailed,
                    callback: function ($$v) {
                      _vm.onlyFailed = $$v
                    },
                    expression: "onlyFailed",
                  },
                },
                [_vm._v(" Only Failed ")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v("Search")]
          ),
        ],
        1
      ),
      _vm.activeTab === "logout"
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "email",
                  label: "Email",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "Name", width: "140" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                (row.firstName || "") +
                                  " " +
                                  (row.lastName || "")
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2965531307
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "Events", width: "80", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tag",
                            { attrs: { type: "danger", size: "small" } },
                            [_vm._v(_vm._s(row.eventCount))]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1141698226
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "Last Event", width: "140" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " + _vm._s(_vm.formatDate(row.lastEventAt)) + " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  926465210
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "Login Date", width: "140" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDate(row.sessionStartedAt)) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1509005187
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "Last Activity", width: "140" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatDate(row.lastActivityAt)) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4063743131
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "Breakdown", width: "180" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          row.tokenExpiredCount
                            ? _c(
                                "span",
                                { staticStyle: { "margin-right": "6px" } },
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: { type: "warning", size: "mini" },
                                    },
                                    [
                                      _vm._v(
                                        "Expired: " +
                                          _vm._s(row.tokenExpiredCount)
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          row.authRejectCount
                            ? _c(
                                "span",
                                [
                                  _c(
                                    "el-tag",
                                    { attrs: { type: "danger", size: "mini" } },
                                    [
                                      _vm._v(
                                        "Reject: " + _vm._s(row.authRejectCount)
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3848150901
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "Platform", width: "120" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return _vm._l(row.platforms || [], function (p) {
                          return _c(
                            "el-tag",
                            {
                              key: p,
                              staticStyle: { margin: "2px" },
                              attrs: {
                                size: "mini",
                                type:
                                  p === "android"
                                    ? "success"
                                    : p === "ios"
                                    ? ""
                                    : "warning",
                              },
                            },
                            [_vm._v(_vm._s(p))]
                          )
                        })
                      },
                    },
                  ],
                  null,
                  false,
                  4010123248
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "",
                  width: "90",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "primary",
                                icon: "el-icon-view",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showUserDetail(row)
                                },
                              },
                            },
                            [_vm._v("Events")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1343192412
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.activeTab === "login"
        ? _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "email",
                  label: "Email",
                  "min-width": "200",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "Name", width: "140" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                (row.firstName || "") +
                                  " " +
                                  (row.lastName || "")
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2965531307
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "Events", width: "80", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("el-tag", { attrs: { size: "small" } }, [
                            _vm._v(_vm._s(row.eventCount)),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2712187495
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "Last Login", width: "140" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _vm._v(
                            " " + _vm._s(_vm.formatDate(row.lastEventAt)) + " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  926465210
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "Breakdown", width: "200" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          row.loginSuccessCount
                            ? _c(
                                "span",
                                { staticStyle: { "margin-right": "6px" } },
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: { type: "success", size: "mini" },
                                    },
                                    [
                                      _vm._v(
                                        "Success: " +
                                          _vm._s(row.loginSuccessCount)
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          row.loginFailedCount
                            ? _c(
                                "span",
                                [
                                  _c(
                                    "el-tag",
                                    { attrs: { type: "danger", size: "mini" } },
                                    [
                                      _vm._v(
                                        "Failed: " +
                                          _vm._s(row.loginFailedCount)
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2835974212
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "Login Type", width: "100" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.getLoginTypeTagType(row.loginType),
                                size: "small",
                              },
                            },
                            [_vm._v(_vm._s(row.loginType || "-"))]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3405144457
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "Platform", width: "120" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return _vm._l(row.platforms || [], function (p) {
                          return _c(
                            "el-tag",
                            {
                              key: p,
                              staticStyle: { margin: "2px" },
                              attrs: {
                                size: "mini",
                                type:
                                  p === "android"
                                    ? "success"
                                    : p === "ios"
                                    ? ""
                                    : "warning",
                              },
                            },
                            [_vm._v(_vm._s(p))]
                          )
                        })
                      },
                    },
                  ],
                  null,
                  false,
                  4010123248
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "",
                  width: "90",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "primary",
                                icon: "el-icon-view",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showUserDetail(row)
                                },
                              },
                            },
                            [_vm._v("Events")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1343192412
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticStyle: {
            "margin-top": "20px",
            display: "flex",
            "justify-content": "flex-end",
          },
        },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next",
              total: _vm.total,
              "page-size": _vm.pageSize,
              "page-sizes": [10, 20, 50, 100],
              "current-page": _vm.currentPage,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handlePageChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Auth History - " + _vm.detailEmail,
            visible: _vm.detailDialogVisible,
            width: "80%",
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.detailLoading,
                  expression: "detailLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.detailList,
                border: "",
                fit: "",
                size: "small",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "Date", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.formatDate(row.createdAt)) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Event", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getEventTypeTagType(row.eventType),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getEventTypeLabel(row.eventType)) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Reason", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.getReasonLabel(row.reason) || "-") +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Platform", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type:
                                row.platform === "android"
                                  ? "success"
                                  : row.platform === "ios"
                                  ? ""
                                  : "warning",
                            },
                          },
                          [_vm._v(_vm._s(row.platform || "-"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "IP",
                  width: "130",
                  prop: "ipAddress",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "Device", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { attrs: { title: row.userAgent } }, [
                          _vm._v(
                            _vm._s(
                              row.deviceInfo ||
                                _vm.truncateText(row.userAgent, 25) ||
                                "-"
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Path", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.metadataJson && row.metadataJson.path
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  color: "#606266",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(row.metadataJson.method) +
                                    " " +
                                    _vm._s(row.metadataJson.path) +
                                    " "
                                ),
                              ]
                            )
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "16px",
                display: "flex",
                "justify-content": "flex-end",
              },
            },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, prev, pager, next",
                  total: _vm.detailTotal,
                  "page-size": 20,
                  "current-page": _vm.detailPage,
                },
                on: { "current-change": _vm.handleDetailPageChange },
              }),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailDialogVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }